package ui.merchantInformation

import ConfigFile
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import androidx.lifecycle.ViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.flow.StateFlow
import model.Card
import model.DataRepository
import model.MerchantFullInformationV3
import model.NavigationRepository
import navigation.NavigationState
import org.koin.compose.koinInject
import ui.DisposableViewModel
import ui.ScopeHolderFactory

@Composable
fun merchantInformationViewModel(
    scopeHolderFactory: ScopeHolderFactory = koinInject(),
): MerchantInformationViewModel {
    val scopeHolder = remember { scopeHolderFactory.getOrCreate(MerchantInformationViewModel::class) }
    DisposableEffect(Unit) { onDispose { scopeHolder.detach() } }
    return remember { scopeHolder.attach() }
}

class MerchantInformationViewModel(
    val clientConfig: ConfigFile,
    private val dataRepository: DataRepository,
    private val navigationRepository: NavigationRepository
) : ViewModel(), DisposableViewModel {

    private val job = SupervisorJob()
    private val viewmodelScope = CoroutineScope(job + Dispatchers.Main)

    val merchantInformationStateFlow: StateFlow<MerchantFullInformationV3?> = dataRepository.merchantInformationStateFlow
    val paymentsStateFlow: StateFlow<DataRepository.PaymentState> = dataRepository.paymentsStateFlow
    val cardsStateFlow: StateFlow<List<Card?>?> = dataRepository.cardsStateFlow


    init {
        println("MerchantInformationViewModel has been created!")
    }

    fun setEreceipt(orderPaymentGuid: String) {
        dataRepository.onTransactionClicked(orderPaymentGuid)
    }

    fun loadPaymentsAsync() {
        dataRepository.loadPaymentsAndConsumerInformationAsync(
            paymentsStateFlow.value.payments,
            merchantInformationStateFlow.value!!.consumerLoyaltyProgramGuid!!
        )
    }

    fun setDemoAdmin(consumerLoyaltyProgramGuid: String) {
        navigationRepository.navigate(NavigationState.DemoMerchantAdmin(consumerLoyaltyProgramGuid))
    }

    override fun dispose() {
        println("MerchantInformationViewModel.dispose()")
        job.cancel()
    }
}